// Add this to your CSS:
// .dm-matter-elem { display: none; }

// Expose a scrollDownHero function for the scroll button
window.scrollDownHero = function() {
  console.log('scrollDownHero called');
  // Find the hero section and scroll to the next sibling section
  var hero = document.querySelector('.lego-hero-container');
  if (!hero) {
    console.log('Hero container not found');
    return;
  }
  
  // Find the parent section (the actual Shopify section)
  var parentSection = hero.closest('[id^="shopify-section-"]');
  if (!parentSection) {
    console.log('Parent section not found');
    return;
  }
  
  var next = parentSection.nextElementSibling;
  if (!next) {
    console.log('No next sibling found');
    return;
  }
  console.log('Scrolling to next section:', next);
  next.scrollIntoView({ behavior: 'smooth' });
};

document.addEventListener('DOMContentLoaded', () => {
  // module aliases
  const { Engine, Render, Runner, Bodies, Composite, MouseConstraint, Mouse, Events } = Matter;

  // create engine & renderer
  const engine = Engine.create();
  const matterBox = document.querySelector('.matter-box');
  const render = Render.create({
    element: matterBox,
    engine,
    options: {
      width: matterBox.clientWidth,
      height: matterBox.clientHeight,
      wireframes: false,
      background: 'transparent'
    }
  });

// helper – tweak the breakpoint to suit
const isDesktop = () => window.matchMedia('(min-width: 1024px)').matches;

// clone each .dm-matter-elem so we have double the bodies – desktop only
if (isDesktop()) {
  const originalElems = Array.from(document.querySelectorAll('.dm-matter-elem'));
  originalElems.forEach(el => {
    const clone = el.cloneNode(true);
    clone.classList.add('dm-matter-elem');
    matterBox.appendChild(clone);
  });
}

// now grab the full list (original + clones, or originals only on mobile)
let matterElems = Array.from(document.querySelectorAll('.dm-matter-elem'));

  // Show elements when JS inits
  matterElems.forEach(el => {
    el.style.display = 'block';
  });

  // create physics bodies at random start positions
  function createBodies() {
    return matterElems.map(el => {
      const { width: w, height: h } = el.getBoundingClientRect();
      const x = Math.random() * (matterBox.clientWidth - w) + w / 2;
      const y = Math.random() * (matterBox.clientHeight - h) + h / 2;
      const angle = Math.random() * 2 * Math.PI;  
      const body = Bodies.rectangle(x, y, w, h, {
        density: 0.01,
        friction: 0.1,
        restitution: 0.5,
        angle: angle, // set initial angle
        render: { opacity: 0 }
      });
      Composite.add(engine.world, body);
      return body;
    });
  }
  let elemBodies = createBodies();

  // invisible walls around the container
  function createBoundaries() {
    const w = matterBox.clientWidth;
    const h = matterBox.clientHeight;
    const thickness = 10;
    const walls = [
      Bodies.rectangle(w/2, h + thickness/2, w, thickness,   { isStatic: true, render: { opacity: 0 } }),
      Bodies.rectangle(w/2, -thickness/2,  w, thickness,   { isStatic: true, render: { opacity: 0 } }),
      Bodies.rectangle(-thickness/2,  h/2, thickness, h,    { isStatic: true, render: { opacity: 0 } }),
      Bodies.rectangle(w + thickness/2, h/2, thickness, h,  { isStatic: true, render: { opacity: 0 } })
    ];
    Composite.add(engine.world, walls);
  }
  createBoundaries();

  // sync DOM elements to physics bodies each tick
  Events.on(engine, 'afterUpdate', () => {
    elemBodies.forEach((body, i) => {
      const el = matterElems[i];
      el.style.left = `${body.position.x - el.offsetWidth/2}px`;
      el.style.top  = `${body.position.y - el.offsetHeight/2}px`;
      el.style.transform = `rotate(${body.angle}rad)`;
    });
  });

 
// runner + mouse
const runner = Runner.create();
const mouse  = Mouse.create(render.canvas);
let mouseConstraint = null;

function addMouseConstraint() {
  if (!mouseConstraint) {
    mouseConstraint = MouseConstraint.create(engine, {
      mouse,
      constraint: { stiffness: 0.2, render: { visible: false } }
    });
    Composite.add(engine.world, mouseConstraint);
  }
  render.mouse = mouse;
  // 🚑 free the scroll wheel
  ['wheel', 'mousewheel', 'DOMMouseScroll'].forEach(evt =>
    mouse.element.removeEventListener(evt, mouse.mousewheel)
  );
}

function removeMouseConstraint() {
  if (mouseConstraint) {
    Composite.remove(engine.world, mouseConstraint);
    mouseConstraint = null;
  }
  render.mouse = null;
}

// Always enable mouse constraint for both desktop and mobile
addMouseConstraint();

  // allow scrolling/swiping through matterBox
  function enableTouchScroll(el) {
    ['mousedown','mousemove','mouseup','touchstart','touchmove','touchend'].forEach(evt => {
      el.removeEventListener(evt, mouse[evt]);
      el.addEventListener(evt, e => {
        // only forward touchmove/up/down when dragging a body
        if (evt.startsWith('touch') ? mouseConstraint.body : true) {
          mouse[evt](e);
        }
      }, { passive: true });
    });
  }
  //enableTouchScroll(mouse.element);

  // handle window resize: clear + rebuild bodies & boundaries
  function handleResize() {
    Composite.clear(engine.world, false);
    createBoundaries();
    matterElems = Array.from(document.querySelectorAll('.dm-matter-elem'));
    elemBodies = createBodies();
    render.options.width  = matterBox.clientWidth;
    render.options.height = matterBox.clientHeight;
    Composite.add(engine.world, mouseConstraint);
  }
  
  window.addEventListener('resize', handleResize);

  // start simulation when matterBox scrolls into view
  let started = false;
  new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting && !started) {
        started = true;
        Runner.run(runner, engine);
        Render.run(render);
      }
    });
  }, { threshold: 0.1 }).observe(matterBox);
});

